import type { TagsCollection } from '@racemap/utilities/functions/timing';
import { castDraft } from 'immer';
import type { FC } from 'react';
import { FilterSelector } from '../BasicComponents/FilterSelector/FilterSelector';
import { IconFilter } from '../Icon';
import { BasicModal } from './BasicModal';
import { areTagsSelected } from './Leaderboard/Columns/TagCol';

interface Props {
  tags: TagsCollection;
  selectedTags: TagsCollection;
  onChange: (tags: TagsCollection) => void;
}

export const FilterModal: FC<Props> = ({ tags, selectedTags, onChange }) => {
  return (
    <BasicModal
      title="Filter:"
      buttonIcon={<IconFilter fixedWidth />}
      activ={areTagsSelected(selectedTags)}
    >
      <FilterSelector
        options={tags}
        value={selectedTags}
        onChange={(tags) => onChange(castDraft(tags))}
        showOptions
      />
    </BasicModal>
  );
};
